(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('PlanDeEstudiosDialogController', PlanDeEstudiosDialogController);

    PlanDeEstudiosDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PlanDeEstudios'];

    function PlanDeEstudiosDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PlanDeEstudios) {
        var vm = this;

        vm.planDeEstudios = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.planDeEstudios.id !== null) {
                PlanDeEstudios.update(vm.planDeEstudios, onSaveSuccess, onSaveError);
            } else {
                PlanDeEstudios.save(vm.planDeEstudios, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:planDeEstudiosUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
